export default "__VITE_ASSET__NiVtk9BW__"